document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('variant-picker:change', function(event) {
    const variant = event.detail?.variant;
    if (!variant || !variant.featured_media) return;

    const mediaId = variant.featured_media.id;
    const productSection = event.target.closest('.product-section, [data-section-type="product"], product-info, .shopify-section');
    if (!productSection) return;

    const mediaGallery = productSection.querySelector('media-gallery, .product__media-gallery');
    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${mediaGallery.dataset.id}-${mediaId}`, true);
    }
  });
});

